import { render } from "./Widgets.vue?vue&type=template&id=1884f412&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=1884f412&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1884f412"]])

export default __exports__